import React from 'react';
import PropTypes from 'prop-types';
import MetaHeader from '../../components/MetaHeader';
import ArticleContainer from '../../components/ArticleContainer';
import { getPricingPageEventLinks } from '../../helpers/event-search';
import { validateAbTest } from '../../helpers/ab-test';
import { getUserOrg } from '../../helpers/user';

const eventMetaSelector = (eventMetas, hasAbTest, userOrg) => ({
  name: eventMetas.event_name,
  performer: eventMetas.performer,
  venue: eventMetas.venue,
  event_date: eventMetas.event_date,
  event_date_local: eventMetas.event_date_local,
  days_until_event: eventMetas.days_until_event,
  on_sale: eventMetas.event_onsale,
  on_sale_local: eventMetas.event_onsale_local,
  currency: eventMetas.currency,
  event_links: getPricingPageEventLinks(
    eventMetas.links,
    eventMetas.event_id,
    eventMetas.skybox_sales_link,
    eventMetas.reps_links,
    userOrg
  ),
  skybox_id: eventMetas.skybox_id,
  event_id: eventMetas.event_id,
  is_ab_test: eventMetas.is_ab_test && hasAbTest,
  automation: eventMetas.automation,
});

const MetaPanelContainer = props => {
  const { eventMeta, isLoading } = props;
  const hasAbTest = validateAbTest();

  const userOrg = getUserOrg();

  if (isLoading) {
    return <ArticleContainer />;
  }
  const newEventData = eventMetaSelector(eventMeta, hasAbTest, userOrg);

  return <MetaHeader eventMeta={newEventData} />;
};

MetaPanelContainer.propTypes = {
  eventMeta: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default MetaPanelContainer;
